import styled from "styled-components"
import React from 'react'
const ImageView = styled.img<{src:string}>`
  /* background-image: url(${p=>p.src});
  background-position: center center; 
  background-repeat: no-repeat;  */
  min-width: 30px;
  min-height: 30px;
  object-fit: fill;
`


enum ImageMode {
  aspectFill = 'aspectFill'  // 缩放模式，保持纵横比缩放图片，只保证图片的短边能完全显示出来。也就是说，图片通常只在水平或垂直方向是完整的，另一个方向将会发生截取。
}


interface ImageProps  extends React.HTMLAttributes<HTMLDivElement> {
  src:string,
  mode?: ImageMode //默认 aspectFill
}

export const Image = (props:ImageProps)=>{
  const { mode = ImageMode.aspectFill } = props
  return <ImageView src={props.src} className={props.className || ''}></ImageView>
}